import axios from './index';

export const getWalletRequest = () => axios.get('/v1/vendors/get/wallet');

export const getDashboardRequest = () => axios.get('/v1/vendors/get/vendor/dashboard');
